import { render, staticRenderFns } from "./MemberManage.vue?vue&type=template&id=e80b292a"
import script from "./MemberManage.vue?vue&type=script&lang=js"
export * from "./MemberManage.vue?vue&type=script&lang=js"
import style0 from "./MemberManage.vue?vue&type=style&index=0&id=e80b292a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports